import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/global.scss'


import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';

import axios from 'axios'

// axios.defaults.baseURL = 'http://127.0.0.1:8000/api';
// axios.defaults.baseURL = 'https://institutesys.mysoftcode.com/api';
axios.defaults.baseURL = 'https://institutesys.mytuitionwave.com/api';
// axios.defaults.baseURL = 'https://graphicwebapi.mysoftcode.com/api';
// axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
// axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
// axios.defaults.headers.common['X-User-ID'] = localStorage.getItem('id');
// axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
// console.log('Base URL:', axios.defaults.baseURL);


// ✅ Axios Request Interceptor to attach token & user ID dynamically
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
//   const userId = localStorage.getItem('id');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

//   if (userId) {
//     config.headers['X-User-ID'] = userId;
//   }

  return config;
}, error => {
  return Promise.reject(error);
});

console.log('Base URL:', axios.defaults.baseURL);

createApp(App).use(store).use(router).mount('#app')




// 🚨 Axios Response Interceptor to catch 401 errors
axios.interceptors.response.use(
  response => response, // Pass through successful responses
  error => {
    if (error.response && error.response.status === 401) {
      // Clear any invalid tokens
      localStorage.removeItem('token');
      localStorage.clear();
    //    window.location.href = '/login';
    //   localStorage.removeItem('id');

      // Optionally, pass an error message via query
      router.push({ path: '/login', query: { error: 'unauthorized' } });
    }

    return Promise.reject(error);
  }
);
